import type { JobItem } from '@core/offers-types';
import { OfferStatus } from '@core/offers-types';

export enum EntityStoreKey {
  JobsBrief = 'JobsBrief',
  JobsItem = 'JobsItem',
  JobsBasic = 'JobsBasic',
  JobsFull = 'JobsFull',
  TalentPoolsBrief = 'TalentPoolsBrief',
  TalentPoolsItem = 'TalentPoolItems',
  TalentPoolsFull = 'TalentPoolsFull',
  OfferLanguagesSetups = 'OfferLanguagesSetups',
  OffersByCompany = 'OffersByCompany',
  PipelineStages = 'PipelineStages',
  JobRequisitions = 'JobRequisitions',
  OfferContentGenerator = 'OfferContentGenerator',
  JobsShared = 'JobsShared',
  OfferTranslations = 'OfferTranslations',
  JobWorkflowAutomations = 'JobWorkflowAutomations',
  JobEvaluationForms = 'JobEvaluationForms',
}

export enum OfferScope {
  Active = 'not_archived',
  Archived = 'archived',
  Shared = 'shared',
}

export const CanAssignToJobsWithStatuses = [
  OfferStatus.Internal,
  OfferStatus.Published,
  OfferStatus.Closed,
];

export type JobsIdMap = Record<number, JobItem>;

export enum FetchOneJobsFullActionContext {
  FetchFullOne = 'FetchFullOne',
  JobUpdatedFromWebsocket = 'JobUpdatedFromWebsocket',
  JobCreatedFromWebsocket = 'JobCreatedFromWebsocket',
}
